import React, { useState, useEffect, useRef } from "react";
import Contacts from "../../services/Contacts";
import Loader from "../../components/Loader";
import NosServices from "../../services/NosServices";
import PopupAlert from "../../components/PopupAlert/PopupAlert";

function ContactForm() {
  const [formData, setFormData] = useState({
    nom: "",
    secteur_activite: "",
    pays: "",
    email: "",
    telephone: "",
    service_id: "",
    budget: "",
    sujet: "",
    message: "",
    doc: null,
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [errorMessage, setErrorMessage] = useState(null);
  const [errors, setErrors] = useState({});
  const [successMessage, setSuccessMessage] = useState(null);
  const [services, setServices] = useState([]);
  const [loading, setLoading] = useState(true);
  const [alert, setAlert] = useState(null);

  const fileInputRef = useRef(null);
  const contactService = new Contacts();
  const nosServices = new NosServices();
  const triggerAlert = (type, message) => {
    setAlert({ type, message });
    setTimeout(() => setAlert(null), 10000);
  };

  useEffect(() => {
    const fetchServices = async () => {
      try {
        const data = await nosServices.getservices();
        setServices(data);
      } catch (error) {
        console.error("Erreur lors de la récupération des services :", error);
      } finally {
        setLoading(false);
      }
    };

    fetchServices();
  }, []);

  if (loading) {
    return (
      <div className="mt-5">
        <Loader width={200} height={200} />
      </div>
    );
  }

  const handleChange = (e) => {
    const { name, value, files } = e.target;
    if (name === "doc") {
      setFormData({ ...formData, doc: files[0] });
    } else {
      setFormData({ ...formData, [name]: value });
    }
  };

  const handleFileClick = () => {
    fileInputRef.current.click();
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setErrorMessage(null);
    setSuccessMessage(null);

    try {
      const formDataToSubmit = new FormData();
      Object.entries(formData).forEach(([key, value]) => {
        if (value !== null) {
          formDataToSubmit.append(key, value);
        }
      });
      const response = await contactService.submitContactForm(formDataToSubmit);
        if (response?.message === "Contact message submitted") {
        setSuccessMessage("Votre demande a été envoyée avec succès !");
        triggerAlert("success", "Votre demande a été envoyée avec succès !");
        setFormData({
          nom: "",
          secteur_activite: "",
          pays: "",
          email: "",
          telephone: "",
          service_id: "",
          budget: "",
          doc: null,
          sujet: "",
          message: "",
        });
      } else {
        setErrors(response?.errors || {});
      }
    } catch (error) {
      setErrorMessage("Une erreur est survenue. Veuillez réessayer.");
      triggerAlert("error", "Une erreur est survenue. Veuillez réessayer.");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <>
      <div className="form-contact card mt-4 shadow-sm">
        <div className="card-body">
          <h2>Lancez-vous</h2>
          <p className="text-muted mb-4">
            Décrivez votre projet et nous vous recontactons sous 24h avec un plan d’action.
          </p>
          {errorMessage && <p className="text-danger">{errorMessage}</p>}
          {successMessage && <p className="text-success">{successMessage}</p>}
          <form onSubmit={handleSubmit}>
            <div className="row g-3">
              <div className="form-contain col-md-6">
                <label htmlFor="nom">
                  Nom/Entreprise <span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  id="nom"
                  name="nom"
                  placeholder="Nom/Entreprise"
                  className="form-control"
                  value={formData.nom}
                  onChange={handleChange}
                  required
                />
                {errors.nom && <small className="text-danger">{errors.nom[0]}</small>}
              </div>
              <div className="form-contain col-md-6">
                <label htmlFor="secteur_activite">
                  Secteur d'activité <span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  id="secteur_activite"
                  name="secteur_activite"
                  placeholder="Commerçant"
                  className="form-control"
                  value={formData.secteur_activite}
                  onChange={handleChange}
                  required
                />
                {errors.secteur_activite && (
                  <small className="text-danger">{errors.secteur_activite[0]}</small>
                )}
              </div>
              <div className="form-contain col-md-6">
                <label htmlFor="pays">
                  Ville, Pays <span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  id="pays"
                  name="pays"
                  className="form-control"
                  placeholder="Dschang, Cameroun"
                  value={formData.pays}
                  onChange={handleChange}
                  required
                />
                {errors.pays && <small className="text-danger">{errors.pays[0]}</small>}
              </div>
              <div className="form-contain col-md-6">
                <label htmlFor="email">
                  Adresse Email <span className="text-danger">*</span>
                </label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  placeholder="text@gmail.com"
                  className="form-control"
                  value={formData.email}
                  onChange={handleChange}
                  required
                />
                {errors.email && <small className="text-danger">{errors.email[0]}</small>}
              </div>
              <div className="form-contain col-md-6">
                <label htmlFor="telephone">
                  Téléphone <span className="text-danger">*</span>
                </label>
                <input
                  type="tel"
                  id="telephone"
                  name="telephone"
                  placeholder="+237xxxxxxxx"
                  className="form-control"
                  value={formData.telephone}
                  onChange={handleChange}
                  required
                />
                {errors.telephone && <small className="text-danger">{errors.telephone[0]}</small>}
              </div>
              <div className="form-contain col-md-6">
                <label htmlFor="service_id">Services</label>
                <select
                  id="service_id"
                  name="service_id"
                  className="form-control"
                  value={formData.service_id}
                  onChange={handleChange}
                >
                  <option value="">Sélectionnez un service</option>
                  {Array.isArray(services) && services.length > 0 ? (
                    services.map((service) => (
                      <option key={service.id} value={service.id}>
                        {service.title}
                      </option>
                    ))
                  ) : (
                    <option disabled>Aucun service disponible</option>
                  )}
                </select>
                {errors.service_id && <small className="text-danger">{errors.service_id[0]}</small>}
              </div>
            </div>
            <div className="row g-3 mt-1">
              <div className="form-contain col-12">
                <label htmlFor="budget">
                  Budget Prévu <span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  id="budget"
                  name="budget"
                  placeholder="1 000 000 XAF"
                  className="form-control"
                  value={formData.budget}
                  onChange={handleChange}
                  required
                />
                {errors.budget && <small className="text-danger">{errors.budget[0]}</small>}
              </div>
              <div className="form-contain col-12">
                <label htmlFor="sujet">Sujet</label>
                <input
                  type="text"
                  id="sujet"
                  name="sujet"
                  placeholder="Sujet"
                  className="form-control"
                  value={formData.sujet}
                  onChange={handleChange}
                  required
                />
                {errors.sujet && <small className="text-danger">{errors.sujet[0]}</small>}
              </div>
              <div className="form-contain col-12">
                <label htmlFor="message">Message</label>
                <textarea
                  id="message"
                  name="message"
                  placeholder="Entrez votre message..."
                  className="form-control"
                  value={formData.message}
                  onChange={handleChange}
                  required
                />
                {errors.message && <small className="text-danger">{errors.message[0]}</small>}
              </div>
              <div className="form-contain col-12">
                <label htmlFor="doc">Document</label>
                <input
                  type="file"
                  id="doc"
                  name="doc"
                  className="form-control"
                  ref={fileInputRef}
                  style={{ display: "none" }}
                  onChange={handleChange}
                />
                <button type="button" onClick={handleFileClick} className="btn btn-outline-secondary btn-sm">
                  Télécharger le document
                </button>
                {formData.doc && (
                  <p className="mt-2 mb-0">Fichier sélectionné : {formData.doc.name}</p>
                )}
              </div>
            </div>
            {/* <CustomCaptcha onVerify={handleCaptchaVerify} /> */}
            <button
              type="submit"
              className={`btn-submit ${isSubmitting ? "disabled" : ""}`}
              disabled={isSubmitting}
            >
              {isSubmitting ? "Envoi en cours..." : "Envoyer la demande"}
            </button>
          </form>
        </div>
      </div>
      {alert && (
        <PopupAlert
          type={alert.type}
          message={alert.message}
          onClose={() => setAlert(null)}
        />
      )}
    </>
  );
}

export default ContactForm;
